import debug from 'debug';
import lukSolidSvg from 'Minetilbud/Shared/Icons/luk_solid.svg';

const log = debug('PopoverService:Templates');

class Templates {
	/**
	 * @param {Object} content 
	 * @param {string} content.primaryColor
	 * @param {string} content.headerTextColor
	 * 
	 * @return {string} Inline styles for the header
	 */
	GetHeaderInlineStyles(content){
		let inlineStyle = '';
		if (content.primaryColor) {
			inlineStyle += `background-color: ${ content.primaryColor };`
		}
		if (content.headerTextColor)
		return inlineStyle += `color: ${ content.headerTextColor }`;
	}

	/**
	 * @param {Object} content 
	 * @param {string} [content.class] override css class
	 * @param {string} [content.headline]
	 * @param {string} content.template Markup to show in the popover
	 * @param {string} content.primaryColor
	 * @param {string} [content.headerTextColor]
	 * 
	 * @return {string} Markup for the popover
	 */
	Markup(content) {
		log('Markup() - content', content);

		return `
			<section data-js="PopoverService" class="o-popover-service ${ typeof content.class !== 'undefined' && content.class !== null ? `${ content.class }` : ''}">
				<span data-js="TriangleUp" class="o-popover-service__triangle-up" style="color: ${ content.primaryColor }">▲</span>
				${ content.headline !== '' ? `
					<h1 class="o-popover-service__headline" style="${ this.GetHeaderInlineStyles(content) }">
						${ content.headline }
						<span class="o-popover-service__close" data-js="PopoverServiceCloseIcon">${ lukSolidSvg }</span>
					</h1>
				` : `` }
				<ul class="o-popover-service__list" data-js="PopoverServiceList">
					${ content.template }
				</ul>
				<span data-js="TriangleDown" class="o-popover-service__triangle-down">▲</span>
			</section>
		`;
	};

}

export default Templates;
